import { render, staticRenderFns } from "./AIGenerateSuggestions.vue?vue&type=template&id=bbdf715e&scoped=true&"
import script from "./AIGenerateSuggestions.vue?vue&type=script&lang=js&"
export * from "./AIGenerateSuggestions.vue?vue&type=script&lang=js&"
import style0 from "./AIGenerateSuggestions.vue?vue&type=style&index=0&id=bbdf715e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbdf715e",
  null
  
)

export default component.exports